<template>
  <page-wrapper :title="pageTitle" :hasPad="true">
    <div class="wrapper">
      <div class="row">
        <div class="col image-container">
          <label class="label">รูป Icon</label>
          <img class="thumbnail" :src="form.iconUrl" />
        </div>
        <div class="col info-container">
          <label class="label">ชื่อ</label>
          <el-input
            class="input"
            v-model="form.featureTitle"
            :readonly="true"
          ></el-input>
          <label class="label">โครงการที่รองรับ</label>
          <div class="editor">
            <project-selector
              :value="form.projects"
              @input="supportedProjectsChanged"
              :disabled="$isCallCenter"
            ></project-selector>
          </div>
          <div class="text-right">
              <sc-button
                variant="primary"
                @click="handleClickSave"
                :disabled="$isCallCenter"
              >บันทึก</sc-button>
            </div>
        </div>
      </div>
    </div>
    
  </page-wrapper>
</template>

<script>
import { Input } from "element-ui";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import ProjectSelector from "@/lib/components/ProjectSelector";
import { baanRueJaiClient } from "@/dependencies";
import { toCamelCaseObject } from '@/lib/util';

export default {
  components: {
    PageWrapper,
    ScButton,
    ProjectSelector,
    "el-input": Input,
  },
  data() {
    const pageTitle = "รายละเอียด Juristic Feature";
    const form = {
      featureTitle: null,
      iconUrl: null,
      projects: []
    };

    return {
      pageTitle,
      form,
    };
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      await this.setupData();
    },
    setupData() {
      this.setupJuristicFeature();
    },
    async setupJuristicFeature() {
      const {
        title: featureTitle,
        icon_url,
        projects
      } = await this.fetchData();

      this.form = {
        ...this.form,
        featureTitle,
        iconUrl: icon_url,
        projects: projects ? toCamelCaseObject(projects) : []
      }
    },
    async fetchData() {
      const juristicFeatureId = this.$route.params.id;
      const response = await baanRueJaiClient.admin.juristicFeature.get(
        juristicFeatureId
      );

      return response.data.result;
    },
    async handleClickSave() {
      if (!confirm("ยืนยันการบันทึก")) {
        return;
      }

      try {
        await this.update();
        this.$router.push({ name: "JuristicFeatureListPage" });
      } catch (err) {
        alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      }
    },
    async update() {
      const juristicFeatureId = this.$route.params.id;
      const params = await this.getUpdateParams();

      const response = await baanRueJaiClient.admin.juristicFeature.put(
        juristicFeatureId,
        params
      );

      return response.data.result;
    },
    async getUpdateParams() {
      const projects = this.form.projects;
      const project_ids = projects.map(item => {
        return item.projectId
      }).sort();
      const params = { project_ids };

      return params;
    },
    supportedProjectsChanged(projects) {
      this.form = {
        ...this.form,
        projects: projects ? projects : []
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.image-container {
  flex: 0 0 225px;
  width: 225px;
}

.info-container {
  max-width: calc(100% - 225px);
}

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.input {
  margin-bottom: 20px;

  &.quota {
    width: 80px;
  }
}

.input > textarea {
  min-height: 120px;
}

.thumbnail,
.image {
  border-radius: $border-radius;
  border: $border;
  width: 100%;
}

.wrapper {
  padding: $space 0 0 0;
}

.editor {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/features/juristic-feature/pages/JuristicFeatureEditor.vue